// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const peid: CountryValidator<"LI"> = createValidator(
  "li.peid",
  114,
);

export default peid;
export const compact = peid.compact;
export const format = peid.format;
export const validate = peid.validate;
export const generate = (): string =>
  peid.generate?.() ??
  (() => {
    throw new Error(
      "Validator li.peid cannot generate values",
    );
  })();
